import React from 'react';
import { CockpitButton } from 'components/views/atoms/CockpitButton';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

export type HelpButtonProps = {
    size?: SizeProp;
    onClick?: () => void;
}

export const HelpButton = (props: HelpButtonProps) => {
    return (
        <CockpitButton icon={faQuestionCircle} {...props} />
    );
};
